import { Alert as AlertWDS, type AlertProps as AlertWDSProps } from "@datamole/wds-component-alert";
import { type ReactNode } from "react";

type Props = { title?: ReactNode; icon?: ReactNode } & AlertWDSProps;

const Alert = (props: Props) => {
    const { severity = "info", title, children, icon, ...otherProps } = props;

    return (
        <AlertWDS {...otherProps} severity={severity}>
            {/* if no icon is provided, it will fallback to default icon */}
            <AlertWDS.Icon>{icon}</AlertWDS.Icon>
            <AlertWDS.Content>
                {title && <AlertWDS.Title>{title}</AlertWDS.Title>}
                <AlertWDS.Content>{children}</AlertWDS.Content>
            </AlertWDS.Content>
        </AlertWDS>
    );
};

export { Alert };
export type { Props as AlertProps };
